export const dashTabQueryKey = 'dash_tab';
